<template>
  <div class="mt-4">
    <b-table
      class="tabela-contas-pagar"
      :items="items"
      :fields="fields"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="sm"
      show-empty
      responsive
      no-local-sorting
      :tbody-tr-class="retornarClasseLinhaAno"
      striped
      hover
      small
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(codigo)="item">
        {{
          item.item.fornecedor
            ? item.item.fornecedor
            : `${item.item.codigo} - ${item.item.historicoDescricao}`
        }}
      </template>
      <template #cell(acoes)="item">
        <b-dropdown
          variant="outline-default"
          v-if="item.item?.statusPagamentoDescricao"
        >
          <b-dropdown-item
            v-if="item.item.statusPagamentoDescricao == 'Aberto' && podeEditar"
            @click="baixarTitulo(item.item.tituloOcorrenciaId)"
          >
            {{ $t('FINANCEIRO.BAIXAR_TITULO') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="
              item.item.statusPagamentoDescricao == 'Liquidado' && podeEditar
            "
            @click="estornarTitulo(item.item)"
          >
            {{ $t('FINANCEIRO.ESTORNAR_TITULO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="confirmarExclusao(item.item)"
            v-if="
              podeExcluir && item.item?.statusPagamentoDescricao != 'Cancelado'
            "
          >
            {{ $t('FINANCEIRO.CANCELAR_TITULO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="ajustarDadosPagamento(item.item)"
            v-if="podeEditar && item.item.statusPagamentoDescricao == 'Aberto'"
          >
            {{ $t('FINANCEIRO.AJUSTAR_DADOS_PAGAMENTO') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(statusPagamentoDescricao)="item">
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Cancelado'"
          style="background: red"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Liquidado'"
          style="background: green"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Liquidado Parcialmente'"
          style="background: #7ccd7c"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Estornado'"
          style="background: #3a443a"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Aberto'"
          style="background: #fbcd00"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          v-if="
            item.item.statusPagamentoDescricao !== 'Aberto' &&
            item.item.statusPagamentoDescricao !== 'Liquidado' &&
            item.item.statusPagamentoDescricao !== 'Liquidado Parcialmente' &&
            item.item.statusPagamentoDescricao !== 'Estornado' &&
            item.item.statusPagamentoDescricao !== 'Cancelado'
          "
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import TituloService from '@/common/services/titulo/titulo.service';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      helpers: helpers,
      fields: [
        // {
        //   key: 'marcar',
        //   label: '',
        // },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
        // {
        //   key: 'fornecedor',
        //   // label: this.$t('FINANCEIRO.FORNECEDOR_DOCUMENTO'),
        //   label: this.$t('FINANCEIRO.FORNECEDOR'),
        //   sortable: true,
        // },
        {
          key: 'codigo',
          label: 'Documento - Histórico',
        },
        {
          key: 'statusPagamentoDescricao',
          label: this.$t('GERAL.STATUS'),
        },
        {
          key: 'dataVencimento',
          label: 'Dt. Venc.',
          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'dataPagamento',
          label: 'Dt. Pag.',

          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
          sortable: true,
        },
        // {
        //   key: 'historicoDescricao',
        //   label: this.$t('GERAL.HISTORICO'),
        // },
        {
          key: 'valor',
          label: this.$t('GERAL.VALOR_BRL'),
          formatter: (value) => {
            return value ? helpers.formatacaoMoedaBRL(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'juros',
          label: this.$t('GERAL.JUROS'),
        },
        {
          key: 'desconto',
          label: this.$t('GERAL.DESCONTO'),
        },
        {
          key: 'total',
          label: this.$t('GERAL.VALOR_EFETIVO'),
          formatter: (value) => {
            return value ? helpers.formatacaoMoedaBRL(value) : '-';
          },
          sortable: true,
        },
        {
          key: 'contaDescricao',
          label: this.$t('FINANCEIRO.CONTA_CAIXA'),
        },
        {
          key: 'descontoObservacao',
          label: this.$t('GERAL.OBSERVACOES'),
        },
        {
          key: 'recibo',
          label: this.$t('FINANCEIRO.RECIBO'),
          // label: this.$t('FINANCEIRO.RECIBO_NF'),
          formatter: (value) => {
            return value === 0 ? '' : value;
          },
        },
        {
          key: 'notaFiscal',
          label: this.$t('SUPRIMENTOS.NOTA_FISCAL'),
        },
        {
          key: 'dataLancamento',
          label: 'Dt. Lanç.',
          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
          sortable: true,
        },
      ],
      itensSelecionados: [],
      listaTemporaria: [],
      selecionarTodos: false,
    };
  },
  watch: {
    items() {
      this.itensSelecionados = [];
      // this.table.items = this.items;
    },
    selecionarTodos: 'marcarDesmarcarTodos',
    filtrarPor: 'limparItensArmazenados',
  },
  methods: {
    // limparItensArmazenados() {
    //   this.itensSelecionados = [];
    //   this.listaTemporaria = [];
    // },
    // // FUNÇÃO PARA MARCAR/DESMARCAR TODOS:
    // marcarDesmarcarTodos() {
    //   // resetando a lista:
    //   this.listaTemporaria = [];

    //   // alterando todos os checked de acordo com o dado do pai:
    //   this.items.forEach((element) => {
    //     element.checked = this.selecionarTodos;
    //     this.listaTemporaria.push(element);
    //   });

    //   // atualizando lista de itens selecionados e emitindo ao pai:
    //   this.itensSelecionados = this.selecionarTodos ? this.listaTemporaria : [];
    //   this.emitirDados();

    //   // retornando a lista temporária:
    //   return (this.items = this.listaTemporaria);
    // },
    // marcaDesmarcaUm(item) {
    //   item.checked ? this.adicionaLista(item) : this.removeLista(item);
    //   this.emitirDados();
    // },
    // adicionaLista(item) {
    //   this.listaTemporaria = this.listaTemporaria.filter(
    //     (element) => element.id != item.id
    //   );
    //   this.listaTemporaria.push(item);
    //   this.itensSelecionados = this.listaTemporaria;
    // },
    // removeLista(item) {
    //   this.listaTemporaria = this.listaTemporaria.filter(
    //     (element) => element.id !== item.id
    //   );
    //   this.itensSelecionados = this.listaTemporaria;
    // },
    // // FUNÇÃO PARA ENVIAR OS DADOS AO PAI:
    // emitirDados() {
    //   // Confere se as matrículas são iguais:
    //   var arr = this.itensSelecionados.map((item) => {
    //     return item.codigoMatricula;
    //   });
    //   const allEqual = arr.every((v) => v === arr[0]);

    //   this.$emit('itens-selecionados-tabela', this.itensSelecionados, allEqual);
    // },
    baixarTitulo(id) {
      this.$emit('baixa-titulo', id);
    },
    ajustarDadosPagamento(item) {
      this.$emit('ajustar-titulo', 'ajustarTitulo', item);
    },
    estornarTitulo(item) {
      this.$store.dispatch(START_LOADING);
      TituloService.estornarContaPagar(item.tituloOcorrenciaId)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Título estornado!');
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        'Confirme o cancelamento',
        'Ao cancelar uma conta, ela é excluída. Deseja realmente excluir esta conta à pagar?'
      );
      if (respostaExclusao.isConfirmed) {
        this.excluir(item);
      }
    },
    retornarClasseLinhaAno(item, type) {
      if (!item || type !== 'row') return;
      const classes = [];
      if (item.fornecedor) classes.push('line-table-custom');
      if (item.statusPagamentoDescricao === 'Liquidado Parcialmente') {
        classes.push('linha-liquidado-parcialmente');
      }
      return classes.join(' ');
    },
    excluir(item) {
      this.$store.dispatch(START_LOADING);
      TituloService.cancelarContaPagar(item.tituloOcorrenciaId)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            'Conta à pagar cancelada!'
          );
          this.$emit('atualiza-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy);
      let ordem = sortDesc;
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>

<style>
.dropdown .btn-outline-default {
  min-height: 15px !important;
  line-height: 0 !important;
}
.tabela-contas-pagar {
  white-space: nowrap;
  font-size: 14px;
}

.tabela-contas-pagar .thead-light th {
  padding: 15px 0.4rem !important;
}

.tabela-contas-pagar td {
  padding: 5px 0.4rem !important;
}

.tabela-contas-pagar tbody tr.linha-liquidado-parcialmente > td {
  background-color: #eaf7ea !important;
  border-top: 1px solid #a8dba8 !important;
}
</style>
